export interface Bq5CargoArrangementsM {
  numberOfHolds: string;
  holdDimensions: {
    holdNumber: number;
    dimensionl: string;
    dimensionw: string;
    dimensionh: string;
    comments: string;
  }[];
  holdsClearAndFree: string;
  holdsClearAndFreeComments: string;
  holdCapacities: {
    holdNumber: number;
    grainCapacity: string;
    baleCapacity: string;
  }[];
  vesselStrenghtnedHeavyCargoes: string;
  vesselStrenghtnedHeavyCargoesComments: string;
  vesselStrenghtnedHeavyCargoesHoldsToBeEmpty: string;
  tanktopSteelSuitableForGrabDischarge: string;
  tanktopSteelSuitableForGrabDischargeComments: string;
  corrugationsOrientation: string;
  corrugationsOrientationComments: string;
  tanktopsStrengths: { holdNumber: number; strength: string }[];
  co2Fitted: string;
  co2FittedComments: string;
  smokeDetection: string;
  smokeDetectionComments: string;
  ahlFitted: string;
  ahlFittedComments: string;
  hullStressDuringCargoHandling: string;
  hullStressDuringCargoHandlingComments: string;
  holdsHopperedAtHoldSide: string;
  holdsHopperedAtHoldSideComments: string;
  holdsHopperedAtForwardBulkhead: string;
  holdsHopperedAtForwardBulkheadComments: string;
  holdsHopperedAtAftBulkhead: string;
  holdsHopperedAtAftBulkheadComments: string;
  boxShaped: string;
  boxShapedComments: string;
  measurementTankSlopesHoppering: string;
  floorMeasurements: { holdNumber: number; floorMeasurement: string }[];
  electricallyVentilated: string;
  electricallyVentilatedComments: string;
  airChangesPerHour: string;
  holdPaintType: string;
  fittedForGrainCarriage: string;
  fittedForGrainCarriageComments: string;
  fittedWithA60: string;
  fittedWithA60Comments: string;
  fittedWithA60Location: string;
  a60Location: string;
  numberOfHatches: string;
  hatchCoverMakeType: string;
  hatchDimensions: { hatchNumber: number; dimensionl: string; dimensionw: string }[];
  hatchSpanDistance: string;
  hatchCoverStrengths: { hatchNumber: number; strength: string }[];
  cementFeederHoles: {
    hatchNumber: number;
    numberDiameter: string;
    location: string;
  }[];
  distanceNearFarEdge: string;
  distanceBowFore: string;
  distanceSternAft: string;
  deckStrength: string;
  deckStrengthComments: string;
  useCalculatedBallast: string;
  calcTotalBallast: string;
  totalBallastTankFull: string;
  ballastHoldsCapacity: string;
  timeReqBallast: string;
  timeReqBallastComments: string;
  maxBallastingRate: string;
  maxBallastingRateComments: string;
  timeReqDeballast: string;
  timeReqDeballastComments: string;
  maxDeballastingRate: string;
  maxDeballastingRateComments: string;
  totalUnpumpableQty: string;
  d1d2PerformanceStandard: string;
  bwTreatmentFitted: string;
  bwTreatmentComments: string;
  bwtsType: string;
  bwtsOtherType: string;
  bwtsManufacturer: string;
  bwtsHasIMOApproval: string;
  bwtsHasUSCGApproval: string;
}

export const initialBq5CargoArrangements: Bq5CargoArrangementsM = {
  numberOfHolds: "",
  holdDimensions: Array.from({ length: 9 }, (_, i) => ({
    holdNumber: i + 1,
    dimensionl: "",
    dimensionw: "",
    dimensionh: "",
    comments: "",
  })),
  holdsClearAndFree: "",
  holdsClearAndFreeComments: "",
  holdCapacities: Array.from({ length: 10 }, (_, i) => ({
    holdNumber: i + 1,
    grainCapacity: "",
    baleCapacity: "",
  })),
  vesselStrenghtnedHeavyCargoes: "",
  vesselStrenghtnedHeavyCargoesComments: "",
  vesselStrenghtnedHeavyCargoesHoldsToBeEmpty: "",
  tanktopSteelSuitableForGrabDischarge: "",
  tanktopSteelSuitableForGrabDischargeComments: "",
  corrugationsOrientation: "",
  corrugationsOrientationComments: "",
  tanktopsStrengths: Array.from({ length: 9 }, (_, i) => ({ holdNumber: i + 1, strength: "" })),
  co2Fitted: "",
  co2FittedComments: "",
  smokeDetection: "",
  smokeDetectionComments: "",
  ahlFitted: "",
  ahlFittedComments: "",
  hullStressDuringCargoHandling: "",
  hullStressDuringCargoHandlingComments: "",
  holdsHopperedAtHoldSide: "",
  holdsHopperedAtHoldSideComments: "",
  holdsHopperedAtForwardBulkhead: "",
  holdsHopperedAtForwardBulkheadComments: "",
  holdsHopperedAtAftBulkhead: "",
  holdsHopperedAtAftBulkheadComments: "",
  boxShaped: "",
  boxShapedComments: "",
  measurementTankSlopesHoppering: "",
  floorMeasurements: Array.from({ length: 9 }, (_, i) => ({
    holdNumber: i + 1,
    floorMeasurement: "",
  })),
  electricallyVentilated: "",
  electricallyVentilatedComments: "",
  airChangesPerHour: "",
  holdPaintType: "",
  fittedForGrainCarriage: "",
  fittedForGrainCarriageComments: "",
  fittedWithA60: "",
  fittedWithA60Comments: "",
  fittedWithA60Location: "",
  a60Location: "",
  numberOfHatches: "",
  hatchCoverMakeType: "",
  hatchDimensions: Array.from({ length: 20 }, (_, i) => ({
    hatchNumber: i + 1,
    dimensionl: "",
    dimensionw: "",
  })),
  hatchSpanDistance: "",
  hatchCoverStrengths: Array.from({ length: 9 }, (_, i) => ({
    hatchNumber: i + 1,
    strength: "",
  })),
  cementFeederHoles: Array.from({ length: 9 }, (_, i) => ({
    hatchNumber: i + 1,
    numberDiameter: "",
    location: "",
  })),
  distanceNearFarEdge: "",
  distanceBowFore: "",
  distanceSternAft: "",
  deckStrength: "",
  deckStrengthComments: "",
  useCalculatedBallast: "",
  calcTotalBallast: "",
  totalBallastTankFull: "",
  ballastHoldsCapacity: "",
  timeReqBallast: "",
  timeReqBallastComments: "",
  maxBallastingRate: "",
  maxBallastingRateComments: "",
  timeReqDeballast: "",
  timeReqDeballastComments: "",
  maxDeballastingRate: "",
  maxDeballastingRateComments: "",
  totalUnpumpableQty: "",
  d1d2PerformanceStandard: "",
  bwTreatmentFitted: "",
  bwTreatmentComments: "",
  bwtsType: "",
  bwtsOtherType: "",
  bwtsManufacturer: "",
  bwtsHasIMOApproval: "",
  bwtsHasUSCGApproval: "",
};

export function mapSqlToBq5CargoArrangementsForm(genInfo: any): Bq5CargoArrangementsM {
  return {
    numberOfHolds: genInfo?.NUMBER_OF_HOLDS || "",
    holdDimensions: [
      {
        holdNumber: 1,
        dimensionl: genInfo?.HOLD_1_DIMENSIONS_L || "",
        dimensionw: genInfo?.HOLD_1_DIMENSIONS_W || "",
        dimensionh: genInfo?.HOLD_1_DIMENSIONS_H || "",
        comments: genInfo?.HOLD_1_COMMENTS || "",
      },
      {
        holdNumber: 2,
        dimensionl: genInfo?.HOLD_2_DIMENSIONS_L || "",
        dimensionw: genInfo?.HOLD_2_DIMENSIONS_W || "",
        dimensionh: genInfo?.HOLD_2_DIMENSIONS_H || "",
        comments: genInfo?.HOLD_2_COMMENTS || "",
      },
      {
        holdNumber: 3,
        dimensionl: genInfo?.HOLD_3_DIMENSIONS_L || "",
        dimensionw: genInfo?.HOLD_3_DIMENSIONS_W || "",
        dimensionh: genInfo?.HOLD_3_DIMENSIONS_H || "",
        comments: genInfo?.HOLD_3_COMMENTS || "",
      },
      {
        holdNumber: 4,
        dimensionl: genInfo?.HOLD_4_DIMENSIONS_L || "",
        dimensionw: genInfo?.HOLD_4_DIMENSIONS_W || "",
        dimensionh: genInfo?.HOLD_4_DIMENSIONS_H || "",
        comments: genInfo?.HOLD_4_COMMENTS || "",
      },
      {
        holdNumber: 5,
        dimensionl: genInfo?.HOLD_5_DIMENSIONS_L || "",
        dimensionw: genInfo?.HOLD_5_DIMENSIONS_W || "",
        dimensionh: genInfo?.HOLD_5_DIMENSIONS_H || "",
        comments: genInfo?.HOLD_5_COMMENTS || "",
      },
      {
        holdNumber: 6,
        dimensionl: genInfo?.HOLD_6_DIMENSIONS_L || "",
        dimensionw: genInfo?.HOLD_6_DIMENSIONS_W || "",
        dimensionh: genInfo?.HOLD_6_DIMENSIONS_H || "",
        comments: genInfo?.HOLD_6_COMMENTS || "",
      },
      {
        holdNumber: 7,
        dimensionl: genInfo?.HOLD_7_DIMENSIONS_L || "",
        dimensionw: genInfo?.HOLD_7_DIMENSIONS_W || "",
        dimensionh: genInfo?.HOLD_7_DIMENSIONS_H || "",
        comments: genInfo?.HOLD_7_COMMENTS || "",
      },
      {
        holdNumber: 8,
        dimensionl: genInfo?.HOLD_8_DIMENSIONS_L || "",
        dimensionw: genInfo?.HOLD_8_DIMENSIONS_W || "",
        dimensionh: genInfo?.HOLD_8_DIMENSIONS_H || "",
        comments: genInfo?.HOLD_8_COMMENTS || "",
      },
      {
        holdNumber: 9,
        dimensionl: genInfo?.HOLD_9_DIMENSIONS_L || "",
        dimensionw: genInfo?.HOLD_9_DIMENSIONS_W || "",
        dimensionh: genInfo?.HOLD_9_DIMENSIONS_H || "",
        comments: genInfo?.HOLD_9_COMMENTS || "",
      },
    ],
    holdsClearAndFree: genInfo?.HOLDS_CLEAR_AND_FREE || "",
    holdsClearAndFreeComments: genInfo?.HOLDS_CLEAR_AND_FREE_COMMENTS || "",
    holdCapacities: [
      {
        holdNumber: 1,
        grainCapacity: genInfo?.HOLD_1_GRAIN_CAPACITY || "",
        baleCapacity: genInfo?.HOLD_1_BALE_CAPACITY || "",
      },
      {
        holdNumber: 2,
        grainCapacity: genInfo?.HOLD_2_GRAIN_CAPACITY || "",
        baleCapacity: genInfo?.HOLD_2_BALE_CAPACITY || "",
      },
      {
        holdNumber: 3,
        grainCapacity: genInfo?.HOLD_3_GRAIN_CAPACITY || "",
        baleCapacity: genInfo?.HOLD_3_BALE_CAPACITY || "",
      },
      {
        holdNumber: 4,
        grainCapacity: genInfo?.HOLD_4_GRAIN_CAPACITY || "",
        baleCapacity: genInfo?.HOLD_4_BALE_CAPACITY || "",
      },
      {
        holdNumber: 5,
        grainCapacity: genInfo?.HOLD_5_GRAIN_CAPACITY || "",
        baleCapacity: genInfo?.HOLD_5_BALE_CAPACITY || "",
      },
      {
        holdNumber: 6,
        grainCapacity: genInfo?.HOLD_6_GRAIN_CAPACITY || "",
        baleCapacity: genInfo?.HOLD_6_BALE_CAPACITY || "",
      },
      {
        holdNumber: 7,
        grainCapacity: genInfo?.HOLD_7_GRAIN_CAPACITY || "",
        baleCapacity: genInfo?.HOLD_7_BALE_CAPACITY || "",
      },
      {
        holdNumber: 8,
        grainCapacity: genInfo?.HOLD_8_GRAIN_CAPACITY || "",
        baleCapacity: genInfo?.HOLD_8_BALE_CAPACITY || "",
      },
      {
        holdNumber: 9,
        grainCapacity: genInfo?.HOLD_9_GRAIN_CAPACITY || "",
        baleCapacity: genInfo?.HOLD_9_BALE_CAPACITY || "",
      },
      {
        holdNumber: 10,
        grainCapacity: genInfo?.HOLD_10_GRAIN_CAPACITY || "",
        baleCapacity: genInfo?.HOLD_10_BALE_CAPACITY || "",
      },
    ],
    vesselStrenghtnedHeavyCargoes: genInfo?.VESSEL_STRENGTHENED_HEAVY_CARGOES || "",
    vesselStrenghtnedHeavyCargoesComments: genInfo?.VESSEL_STRENGTHENED_HEAVY_CARGOES_COMMENTS || "",
    vesselStrenghtnedHeavyCargoesHoldsToBeEmpty: genInfo?.VESSEL_HEAVY_CARGOES_HOLDS_TO_BE_EMPTY || "",
    tanktopSteelSuitableForGrabDischarge: genInfo?.TANKTOP_STEEL_SUITABLE_FOR_GRAB_DISCHARGE || "",
    tanktopSteelSuitableForGrabDischargeComments: genInfo?.TANKTOP_STEEL_SUITABLE_FOR_GRAB_DISCHARGE_COMMENTS || "",
    corrugationsOrientation: genInfo?.CORRUGATIONS_ORIENTATION || "",
    corrugationsOrientationComments: genInfo?.CORRUGATIONS_ORIENTATION_COMMENTS || "",
    tanktopsStrengths: [
      { holdNumber: 1, strength: genInfo?.HOLD_1_TANKTOP_STRENGTH || "" },
      { holdNumber: 2, strength: genInfo?.HOLD_2_TANKTOP_STRENGTH || "" },
      { holdNumber: 3, strength: genInfo?.HOLD_3_TANKTOP_STRENGTH || "" },
      { holdNumber: 4, strength: genInfo?.HOLD_4_TANKTOP_STRENGTH || "" },
      { holdNumber: 5, strength: genInfo?.HOLD_5_TANKTOP_STRENGTH || "" },
      { holdNumber: 6, strength: genInfo?.HOLD_6_TANKTOP_STRENGTH || "" },
      { holdNumber: 7, strength: genInfo?.HOLD_7_TANKTOP_STRENGTH || "" },
      { holdNumber: 8, strength: genInfo?.HOLD_8_TANKTOP_STRENGTH || "" },
      { holdNumber: 9, strength: genInfo?.HOLD_9_TANKTOP_STRENGTH || "" },
    ],
    co2Fitted: genInfo?.CO2_FITTED || "",
    co2FittedComments: genInfo?.CO2_FITTED_COMMENTS || "",
    smokeDetection: genInfo?.SMOKE_DETECTION || "",
    smokeDetectionComments: genInfo?.SMOKE_DETECTION_COMMENTS || "",
    ahlFitted: genInfo?.AHL_FITTED || "",
    ahlFittedComments: genInfo?.AHL_FITTED_COMMENTS || "",
    hullStressDuringCargoHandling: genInfo?.HULL_STRESS_DURING_CARGO_HANDLING || "",
    hullStressDuringCargoHandlingComments: genInfo?.HULL_STRESS_DURING_CARGO_HANDLING_COMMENTS || "",
    holdsHopperedAtHoldSide: genInfo?.HOLDS_HOPPERED_AT_HOLD_SIDE || "",
    holdsHopperedAtHoldSideComments: genInfo?.HOLDS_HOPPERED_AT_HOLD_SIDE_COMMENTS || "",
    holdsHopperedAtForwardBulkhead: genInfo?.HOLDS_HOPPERED_AT_FORWARD_BULKHEAD || "",
    holdsHopperedAtForwardBulkheadComments: genInfo?.HOLDS_HOPPERED_AT_FORWARD_BULKHEAD_COMMENTS || "",
    holdsHopperedAtAftBulkhead: genInfo?.HOLDS_HOPPERED_AT_AFT_BULKHEAD || "",
    holdsHopperedAtAftBulkheadComments: genInfo?.HOLDS_HOPPERED_AT_AFT_BULKHEAD_COMMENTS || "",
    boxShaped: genInfo?.BOX_SHAPED || "",
    boxShapedComments: genInfo?.BOX_SHAPED_COMMENTS || "",
    measurementTankSlopesHoppering: genInfo?.MEASUREMENT_TANK_SLOPES_HOPPERING || "",
    floorMeasurements: [
      { holdNumber: 1, floorMeasurement: genInfo?.HOLD_1_FLOOR_MEASUREMENT || "" },
      { holdNumber: 2, floorMeasurement: genInfo?.HOLD_2_FLOOR_MEASUREMENT || "" },
      { holdNumber: 3, floorMeasurement: genInfo?.HOLD_3_FLOOR_MEASUREMENT || "" },
      { holdNumber: 4, floorMeasurement: genInfo?.HOLD_4_FLOOR_MEASUREMENT || "" },
      { holdNumber: 5, floorMeasurement: genInfo?.HOLD_5_FLOOR_MEASUREMENT || "" },
      { holdNumber: 6, floorMeasurement: genInfo?.HOLD_6_FLOOR_MEASUREMENT || "" },
      { holdNumber: 7, floorMeasurement: genInfo?.HOLD_7_FLOOR_MEASUREMENT || "" },
      { holdNumber: 8, floorMeasurement: genInfo?.HOLD_8_FLOOR_MEASUREMENT || "" },
      { holdNumber: 9, floorMeasurement: genInfo?.HOLD_9_FLOOR_MEASUREMENT || "" },
    ],
    electricallyVentilated: genInfo?.ELECTRICALLY_VENTILATED || "",
    electricallyVentilatedComments: genInfo?.ELECTRICALLY_VENTILATED_COMMENTS || "",
    airChangesPerHour: genInfo?.AIR_CHANGES_PER_HOUR || "",
    holdPaintType: genInfo?.HOLD_PAINT_TYPE || "",
    fittedForGrainCarriage: genInfo?.FITTED_FOR_GRAIN_CARRIAGE || "",
    fittedForGrainCarriageComments: genInfo?.FITTED_FOR_GRAIN_CARRIAGE_COMMENTS || "",
    fittedWithA60: genInfo?.FITTED_WITH_A60 || "",
    fittedWithA60Comments: genInfo?.FITTED_WITH_A60_COMMENTS || "",
    fittedWithA60Location: genInfo?.FITTED_WITH_A60_LOCATION || "",
    a60Location: genInfo?.A60_LOCATION || "",
    numberOfHatches: genInfo?.NUMBER_OF_HATCHES || "",
    hatchCoverMakeType: genInfo?.HATCH_COVER_MAKE_TYPE || "",
    hatchDimensions: [
      {
        hatchNumber: 1,
        dimensionl: genInfo?.HATCH_1_DIMENSIONS_L || "",
        dimensionw: genInfo?.HATCH_1_DIMENSIONS_W || "",
      },
      {
        hatchNumber: 2,
        dimensionl: genInfo?.HATCH_2_DIMENSIONS_L || "",
        dimensionw: genInfo?.HATCH_2_DIMENSIONS_W || "",
      },
      {
        hatchNumber: 3,
        dimensionl: genInfo?.HATCH_3_DIMENSIONS_L || "",
        dimensionw: genInfo?.HATCH_3_DIMENSIONS_W || "",
      },
      {
        hatchNumber: 4,
        dimensionl: genInfo?.HATCH_4_DIMENSIONS_L || "",
        dimensionw: genInfo?.HATCH_4_DIMENSIONS_W || "",
      },
      {
        hatchNumber: 5,
        dimensionl: genInfo?.HATCH_5_DIMENSIONS_L || "",
        dimensionw: genInfo?.HATCH_5_DIMENSIONS_W || "",
      },
      {
        hatchNumber: 6,
        dimensionl: genInfo?.HATCH_6_DIMENSIONS_L || "",
        dimensionw: genInfo?.HATCH_6_DIMENSIONS_W || "",
      },
      {
        hatchNumber: 7,
        dimensionl: genInfo?.HATCH_7_DIMENSIONS_L || "",
        dimensionw: genInfo?.HATCH_7_DIMENSIONS_W || "",
      },
      {
        hatchNumber: 8,
        dimensionl: genInfo?.HATCH_8_DIMENSIONS_L || "",
        dimensionw: genInfo?.HATCH_8_DIMENSIONS_W || "",
      },
      {
        hatchNumber: 9,
        dimensionl: genInfo?.HATCH_9_DIMENSIONS_L || "",
        dimensionw: genInfo?.HATCH_9_DIMENSIONS_W || "",
      },
      {
        hatchNumber: 10,
        dimensionl: genInfo?.HATCH_10_DIMENSIONS_L || "",
        dimensionw: genInfo?.HATCH_10_DIMENSIONS_W || "",
      },
      {
        hatchNumber: 11,
        dimensionl: genInfo?.HATCH_11_DIMENSIONS_L || "",
        dimensionw: genInfo?.HATCH_11_DIMENSIONS_W || "",
      },
      {
        hatchNumber: 12,
        dimensionl: genInfo?.HATCH_12_DIMENSIONS_L || "",
        dimensionw: genInfo?.HATCH_12_DIMENSIONS_W || "",
      },
      {
        hatchNumber: 13,
        dimensionl: genInfo?.HATCH_13_DIMENSIONS_L || "",
        dimensionw: genInfo?.HATCH_13_DIMENSIONS_W || "",
      },
      {
        hatchNumber: 14,
        dimensionl: genInfo?.HATCH_14_DIMENSIONS_L || "",
        dimensionw: genInfo?.HATCH_14_DIMENSIONS_W || "",
      },
      {
        hatchNumber: 15,
        dimensionl: genInfo?.HATCH_15_DIMENSIONS_L || "",
        dimensionw: genInfo?.HATCH_15_DIMENSIONS_W || "",
      },
      {
        hatchNumber: 16,
        dimensionl: genInfo?.HATCH_16_DIMENSIONS_L || "",
        dimensionw: genInfo?.HATCH_16_DIMENSIONS_W || "",
      },
      {
        hatchNumber: 17,
        dimensionl: genInfo?.HATCH_17_DIMENSIONS_L || "",
        dimensionw: genInfo?.HATCH_17_DIMENSIONS_W || "",
      },
      {
        hatchNumber: 18,
        dimensionl: genInfo?.HATCH_18_DIMENSIONS_L || "",
        dimensionw: genInfo?.HATCH_18_DIMENSIONS_W || "",
      },
      {
        hatchNumber: 19,
        dimensionl: genInfo?.HATCH_19_DIMENSIONS_L || "",
        dimensionw: genInfo?.HATCH_19_DIMENSIONS_W || "",
      },
      {
        hatchNumber: 20,
        dimensionl: genInfo?.HATCH_20_DIMENSIONS_L || "",
        dimensionw: genInfo?.HATCH_20_DIMENSIONS_W || "",
      },
    ],
    hatchSpanDistance: genInfo?.HATCH_SPAN_DISTANCE || "",
    hatchCoverStrengths: [
      { hatchNumber: 1, strength: genInfo?.HATCH_1_STRENGTH || "" },
      { hatchNumber: 2, strength: genInfo?.HATCH_2_STRENGTH || "" },
      { hatchNumber: 3, strength: genInfo?.HATCH_3_STRENGTH || "" },
      { hatchNumber: 4, strength: genInfo?.HATCH_4_STRENGTH || "" },
      { hatchNumber: 5, strength: genInfo?.HATCH_5_STRENGTH || "" },
      { hatchNumber: 6, strength: genInfo?.HATCH_6_STRENGTH || "" },
      { hatchNumber: 7, strength: genInfo?.HATCH_7_STRENGTH || "" },
      { hatchNumber: 8, strength: genInfo?.HATCH_8_STRENGTH || "" },
      { hatchNumber: 9, strength: genInfo?.HATCH_9_STRENGTH || "" },
      { hatchNumber: 10, strength: genInfo?.HATCH_10_STRENGTH || "" },
      { hatchNumber: 11, strength: genInfo?.HATCH_11_STRENGTH || "" },
      { hatchNumber: 12, strength: genInfo?.HATCH_12_STRENGTH || "" },
      { hatchNumber: 13, strength: genInfo?.HATCH_13_STRENGTH || "" },
      { hatchNumber: 14, strength: genInfo?.HATCH_14_STRENGTH || "" },
      { hatchNumber: 15, strength: genInfo?.HATCH_15_STRENGTH || "" },
      { hatchNumber: 16, strength: genInfo?.HATCH_16_STRENGTH || "" },
      { hatchNumber: 17, strength: genInfo?.HATCH_17_STRENGTH || "" },
      { hatchNumber: 18, strength: genInfo?.HATCH_18_STRENGTH || "" },
      { hatchNumber: 19, strength: genInfo?.HATCH_19_STRENGTH || "" },
      { hatchNumber: 20, strength: genInfo?.HATCH_20_STRENGTH || "" },
    ],
    cementFeederHoles: [
      {
        hatchNumber: 1,
        numberDiameter: genInfo?.CEMENT_FEEDER_1_DIAMETER || "",
        location: genInfo?.CEMENT_FEEDER_1_LOCATION || "",
      },
      {
        hatchNumber: 2,
        numberDiameter: genInfo?.CEMENT_FEEDER_2_DIAMETER || "",
        location: genInfo?.CEMENT_FEEDER_2_LOCATION || "",
      },
      {
        hatchNumber: 3,
        numberDiameter: genInfo?.CEMENT_FEEDER_3_DIAMETER || "",
        location: genInfo?.CEMENT_FEEDER_3_LOCATION || "",
      },
      {
        hatchNumber: 4,
        numberDiameter: genInfo?.CEMENT_FEEDER_4_DIAMETER || "",
        location: genInfo?.CEMENT_FEEDER_4_LOCATION || "",
      },
      {
        hatchNumber: 5,
        numberDiameter: genInfo?.CEMENT_FEEDER_5_DIAMETER || "",
        location: genInfo?.CEMENT_FEEDER_5_LOCATION || "",
      },
      {
        hatchNumber: 6,
        numberDiameter: genInfo?.CEMENT_FEEDER_6_DIAMETER || "",
        location: genInfo?.CEMENT_FEEDER_6_LOCATION || "",
      },
      {
        hatchNumber: 7,
        numberDiameter: genInfo?.CEMENT_FEEDER_7_DIAMETER || "",
        location: genInfo?.CEMENT_FEEDER_7_LOCATION || "",
      },
      {
        hatchNumber: 8,
        numberDiameter: genInfo?.CEMENT_FEEDER_8_DIAMETER || "",
        location: genInfo?.CEMENT_FEEDER_8_LOCATION || "",
      },
      {
        hatchNumber: 9,
        numberDiameter: genInfo?.CEMENT_FEEDER_9_DIAMETER || "",
        location: genInfo?.CEMENT_FEEDER_9_LOCATION || "",
      },
      {
        hatchNumber: 10,
        numberDiameter: genInfo?.CEMENT_FEEDER_10_DIAMETER || "",
        location: genInfo?.CEMENT_FEEDER_10_LOCATION || "",
      },
      {
        hatchNumber: 11,
        numberDiameter: genInfo?.CEMENT_FEEDER_11_DIAMETER || "",
        location: genInfo?.CEMENT_FEEDER_11_LOCATION || "",
      },
      {
        hatchNumber: 12,
        numberDiameter: genInfo?.CEMENT_FEEDER_12_DIAMETER || "",
        location: genInfo?.CEMENT_FEEDER_12_LOCATION || "",
      },
      {
        hatchNumber: 13,
        numberDiameter: genInfo?.CEMENT_FEEDER_13_DIAMETER || "",
        location: genInfo?.CEMENT_FEEDER_13_LOCATION || "",
      },
      {
        hatchNumber: 14,
        numberDiameter: genInfo?.CEMENT_FEEDER_14_DIAMETER || "",
        location: genInfo?.CEMENT_FEEDER_14_LOCATION || "",
      },
      {
        hatchNumber: 15,
        numberDiameter: genInfo?.CEMENT_FEEDER_15_DIAMETER || "",
        location: genInfo?.CEMENT_FEEDER_15_LOCATION || "",
      },
      {
        hatchNumber: 16,
        numberDiameter: genInfo?.CEMENT_FEEDER_16_DIAMETER || "",
        location: genInfo?.CEMENT_FEEDER_16_LOCATION || "",
      },
      {
        hatchNumber: 17,
        numberDiameter: genInfo?.CEMENT_FEEDER_17_DIAMETER || "",
        location: genInfo?.CEMENT_FEEDER_17_LOCATION || "",
      },
      {
        hatchNumber: 18,
        numberDiameter: genInfo?.CEMENT_FEEDER_18_DIAMETER || "",
        location: genInfo?.CEMENT_FEEDER_18_LOCATION || "",
      },
      {
        hatchNumber: 19,
        numberDiameter: genInfo?.CEMENT_FEEDER_19_DIAMETER || "",
        location: genInfo?.CEMENT_FEEDER_19_LOCATION || "",
      },
      {
        hatchNumber: 20,
        numberDiameter: genInfo?.CEMENT_FEEDER_20_DIAMETER || "",
        location: genInfo?.CEMENT_FEEDER_20_LOCATION || "",
      },
    ],
    distanceNearFarEdge: genInfo?.DISTANCE_NEAR_FAR_EDGE || "",
    distanceBowFore: genInfo?.DISTANCE_BOW_FORE || "",
    distanceSternAft: genInfo?.DISTANCE_STERN_AFT || "",
    deckStrength: genInfo?.DECK_STRENGTH || "",
    deckStrengthComments: genInfo?.DECK_STRENGTH_COMMENTS || "",
    useCalculatedBallast: genInfo?.USE_CALCULATED_BALLAST || "",
    calcTotalBallast: genInfo?.CALC_TOTAL_BALLAST || "",
    totalBallastTankFull: genInfo?.TOTAL_BALLAST_TANK_FULL || "",
    ballastHoldsCapacity: genInfo?.BALLAST_HOLDS_CAPACITY || "",
    timeReqBallast: genInfo?.TIME_REQ_BALLAST || "",
    timeReqBallastComments: genInfo?.TIME_REQ_BALLAST_COMMENTS || "",
    timeReqDeballast: genInfo?.TIME_REQ_DEBALLAST || "",
    timeReqDeballastComments: genInfo?.TIME_REQ_DEBALLAST_COMMENTS || "",
    maxBallastingRate: genInfo?.MAX_BALLASTING_RATE || "",
    maxBallastingRateComments: genInfo?.MAX_BALLASTING_RATE_COMMENTS || "",
    maxDeballastingRate: genInfo?.MAX_DEBALLASTING_RATE || "",
    maxDeballastingRateComments: genInfo?.MAX_DEBALLASTING_RATE_COMMENTS || "",
    totalUnpumpableQty: genInfo?.TOTAL_UNPUMPABLE_QTY || "",
    d1d2PerformanceStandard: genInfo?.D1_D2_PERFORMANCE_STANDARD || "",
    bwTreatmentFitted: genInfo?.BW_TREATMENT_FITTED || "",
    bwTreatmentComments: genInfo?.BW_TREATMENT_COMMENTS || "",
    bwtsType: genInfo?.BWTS_TYPE || "",
    bwtsOtherType: genInfo?.BWTS_OTHER_TYPE || "",
    bwtsManufacturer: genInfo?.BWTS_MANUFACTURER || "",
    bwtsHasIMOApproval: genInfo?.BWTS_HAS_IMO_APPROVAL || "",
    bwtsHasUSCGApproval: genInfo?.BWTS_HAS_USCG_APPROVAL || "",
  };
}
